export abstract class Constants {
    static readonly CONTROLS: string = "controls";
    static readonly SURNAME: string = "surname";
    static readonly FORENAMEONE: string = "forenameOne";
    static readonly FORENAMETWO: string = "forenameTwo";
    static readonly CONDITIONAL_QUESTIONS: string = "conditional_question";
    static readonly QUESTIONS: string = "questions";

    // Old id values (kept in for reference)
    // static readonly ADULT_RENEWAL_APPLICATION: number = 9;
    // static readonly CHILD_RENEWAL_APPLICATION: number = 10;
    // static readonly CHILD_FIRST_TIME_APPLICATION: number = 11;
    // static readonly ADULT_FIRST_TIME_APPLICATION: number = 12;

    static readonly ADULT_RENEWAL_APPLICATION: string  = "Adult Renewal Application | Iarratas Athnuachana do Dhuine Fásta";
    static readonly CHILD_RENEWAL_APPLICATION: string = "Child Renewal Application | Iarratas Athnuachana do Leanbh";
    static readonly CHILD_FIRST_TIME_APPLICATION: string = "Child First Time Application | Iarratas Céaduaire do Leanbh";
    static readonly ADULT_FIRST_TIME_APPLICATION: string = "Adult First Time Application | Iarratas Céaduaire do Dhuine Fásta";

    static readonly NO_15_YEARS: number = 14;
    static readonly NO_CITIZENSHIP: number = 25;
    static readonly YES_BORN_IN_IRELAND: number = 22;
    static readonly DAY: string = "Day | Lá";
    static readonly MONTH: string = "Month | Mí";
    static readonly YEAR: string = "Year | Bliain";
    static readonly DAY_FORMAT: string = "numeric";
    static readonly MONTH_FORMAT: string = "long";
    static readonly YEAR_FORMAT: string = "numeric";
}